import { render, staticRenderFns } from "./PhoneBook.vue?vue&type=template&id=4f53b522&"
import script from "./PhoneBook.vue?vue&type=script&lang=js&"
export * from "./PhoneBook.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports